import { FC, memo } from 'react'
import { Button } from '@chakra-ui/react'

import RoleCard from 'Attendances/components/RoleCard'
import { Role } from 'Attendances/types'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import { useCustomFormRoleSelectionDrawerManager } from '../../../../contexts/CustomFormRoleSelectionDrawerManager/Provider'

type Props = {
  role: Role
  onClose: () => void
}

const CustomFormRoleCardToSelect: FC<Props> = ({ role, onClose }) => {
  const { questionKey, selectedRole, setSelectedRole, filter } = useCustomFormRoleSelectionDrawerManager()

  const { formMethods } = useCustomFormViewer()

  function selectRole(selectedRole: Role) {
    formMethods?.setValue(questionKey, [selectedRole.id, selectedRole.slug, selectedRole.name])
    setSelectedRole(selectedRole)
  }

  function removeRole() {
    formMethods?.setValue(questionKey, undefined)
    setSelectedRole({})
  }

  return (
    <RoleCard roleInformation={role} roleFilter={filter}>
      {selectedRole?.id === role.id ? (
        <Button width="100%" variant="outline" colorScheme="red" onClick={() => removeRole()}>
          Remover
        </Button>
      ) : (
        <Button
          width="100%"
          variant="outline"
          onClick={() => {
            selectRole(role)
            onClose()
          }}
        >
          Selecionar
        </Button>
      )}
    </RoleCard>
  )
}

export default memo(CustomFormRoleCardToSelect)
